import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const offerSelector = createSelector(testTargetOffersSelector, offers => offers.shopYourStorePreselectFulfillment || Empty.Object);
const showSelector = createSelector(offerSelector, shopYourStorePreselectFulfillment => !!shopYourStorePreselectFulfillment.show);
const showShopYourStorePreselectFulfillmentAbTestSelector = createSelector(
    isTestTargetReadySelector,
    showSelector,
    (testReady, show) => testReady && show
);

export { showShopYourStorePreselectFulfillmentAbTestSelector };
